import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./assets/icons"; // icon

//前端ui框架 element-ui  官方地址： https://element.eleme.cn/#/zh-CN/component/installation
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Element)

// 引入css重置样式表
// import './assets/style/reset.css'
// import './assets/style/publicStyle.css'
import './assets/style/responsiveLayout.scss'
import './assets/style/gwkj-element-ui.scss'
  

// D:\项目文件夹\历史代码留档\弓网科技官网\src\assets\style\mediamin1400.css


// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts;


// // 首页引导插件
// import intro from 'intro.js' // introjs库
// import 'intro.js/introjs.css' // introjs默认css样式
// // introjs还提供了多种主题，可以通过以下方式引入
// import 'intro.js/themes/introjs-modern.css' // introjs主题

// // 把intro.js加入到vue的prototype中，方便使用，就可以直接通过this.$intro()来调用了
// Vue.prototype.$intro = intro



// // 自定义分页组件
// import Pagination from './components/Pagenation/Pagenation.vue'
// Vue.component('Pagination', Pagination)

// Vue.config.productionTip = false
import i18n from './i18n/index.js';

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
